const theme = {
    primary: '#CD2828',
    white: '#FFFFFF',
    grey: '#3C3C3C',
    lightGrey: '#F0F0F0',
    pink: '#FFA489',
    heath: '#4D0F0F',
    blue: '#135680',
    green: '#CCCA3D'
}

export default theme